import { defineStore } from 'pinia';

export const useAppStore = defineStore({
    id: 'app',
    state: () => ({
        search: {
            article: {
                term: "",
                category: 0
            }
        }
    }),
    actions: {
        setSearchArticleState(term, category) {
            this.search.article.term = term;
            this.search.article.category = category;
        },
        getSearchArticleState() {
            return this.search.article;
        }
    },
});